<script setup lang="ts">
const { t } = useI18n()

const items = [
    {
        name: t("partials.howTo.howTo1.title"),
        description: t("partials.howTo.howTo1.description"),
        image: '/images/partials/how-to-1.svg'
    },
    {
        name: t("partials.howTo.howTo2.title"),
        description: t("partials.howTo.howTo2.description"),
        image: '/images/partials/how-to-2.svg'
    },
    {
        name: t("partials.howTo.howTo3.title"),
        description: t("partials.howTo.howTo3.description"),
        image: '/images/partials/how-to-3.svg'
    },
]
</script>

<template>
    <UContainer class="flex flex-col">
        <div class="flex flex-col gap-4.5 items-center lg:max-w-[800px] mx-auto">
            <h2 class="uppercase text-center text-[#69330A] text-[30px] leading-[38px] sm:text-[36px] sm:leading-[46px]">{{ t("partials.howTo.title") }}</h2>
            <p class="text-center text-[#69330A]">{{ t("partials.howTo.description") }}</p>
        </div>
        <UCarousel v-slot="{ item, index }" :items="items" :ui="{ item: 'basis-3/4 sm:basis-1/3 ps-8', container: '-ms-8', dot: 'bg-[#F28B3D] border-[#F28B3D]' }" :align="'start'" :arrows="true" :dots="true" prevIcon="i-lyra-guides-review-arrow-orange-prev" nextIcon="i-lyra-guides-review-arrow-orange-next" class="how-to-carousel w-full mx-auto sm:pointer-events-none">
            <div class="relative pt-[50px] lg:pt-[70px] cursor-grab select-none">
                <span class="how-to-numbers font-bold text-[70px] lg:text-[93px] text-[#69330A] -mb-8 lg:-mb-24 absolute left-8 top-0 z-1">{{ index + 1 }}</span>
                <div class="bg-[#FAE5D4] flex flex-col items-center justify-center gap-2 md:gap-4.5 pt-6 pb-[34px] px-4 lg:py-16 lg:px-12 rounded-[48px] overflow-visible">
                    <NuxtImg :src="item.image" :alt="item.name" class="w-full h-auto mb-2.5 md:mb-0" />
                    <span class="how-to-title block text-center uppercase text-[#914C16] font-bold text-[16px] leading-[22px] lg:text-[28px] lg:leading-[36px]">{{ item.name }}</span>
                    <p class="text-center">{{ item.description }}</p>
                </div>
            </div>
        </UCarousel>
    </UContainer>
</template>

<style>
@media (min-width: 640px) {
    .how-to-carousel {
        .carousel-arrows, .carousel-dots {
            display: none !important;
        }
    }
}
.how-to-numbers, .how-to-title {
    font-family: "Quicksand", sans-serif;
}
.how-to-carousel {
    @media (max-width: 639px) {
        .carousel-arrows button {
            bottom: -1.25em !important;
            top: unset !important;
            font-size: 20px !important;
        }
    }
}
</style>
